export type CodeSandboxImport = {
  module?: any;
  version: string;
  required: boolean;
};

export type CodeSandboxLanguage = 'js' | 'ts';
